import * as React from 'react';
import './OrText.css';

export  default function OrText(props) {
    return (
        <div className="or-text">Or, {props.message}:</div>
    );
}
